module.exports = __webpack_public_path__ + "static/media/06-icon.48c30c17.svg";